// extracted by mini-css-extract-plugin
export default {"spinner":"spinner_Spinner-module_3HOcZ","rotateRectangle":"rotateRectangle_Spinner-module_K5MrA"};